export default "__VITE_ASSET__Cj_oG4Nf__"